import { CatalogItemsAPI, getItemsTagAPI } from "../ApiStore/apiStore";


const GET_TAG_ITEMS = "GET-TAG-ITEMS";
const GET_POPULAR_ITEMS = "GET-POPULAR-ITEMS";
const TOGGLE_IS_DISPETCHER_TAG = "TOGGLE_IS_DISPETCHER_TAG";
const TOGGLE_IS_DISPETCHER_POPULAR= "TOGGLE_IS_DISPETCHER_POPULAR";

let initialState = {
    itemsPopular: [],
    isFetchingPopularItems: true,
    itemsTag: [],
    isFetchingTagsItems: true,
    pageSize: 48,
    totalItemsCount: 100,
    currentPage: 1,
}

const indexPageReducer = (state = initialState, action) => {

    switch (action.type) {

        case GET_TAG_ITEMS: {

            return {
                ...state,
                itemsTag: action.itemsTag
            }
        }
        case GET_POPULAR_ITEMS: {

            return {
                ...state,
                itemsPopular: action.itemsPopular
            }
        }
        case TOGGLE_IS_DISPETCHER_TAG: {

            return {
                ...state,
                isFetchingTagsItems: action.isFetchingTagsItems
            }
        }
        case TOGGLE_IS_DISPETCHER_POPULAR: {

            return {
                ...state,
                isFetchingPopularItems: action.isFetchingPopularItems
            }
        }
        default: {
            return state;
        }
    }

}


export const getPopularAtemsAC = (itemsPopular) => {

    return {
        type: GET_POPULAR_ITEMS, itemsPopular
    }
}
export const setToggleDispetcherPopular = (isFetchingPopularItems) => {
    return {
        type: TOGGLE_IS_DISPETCHER_POPULAR, isFetchingPopularItems
    }
}

export const setPopularItems = (pageSize = '30', currentPage = '1', filtr = "") => async (dispatch) => {

    dispatch(setToggleDispetcherPopular(true));
    let data = await CatalogItemsAPI.CatalogItems(pageSize, currentPage, filtr = "&filter[ORGANZA_POPULAR][]=6559&sort_by=id&sort_dir=desc&indexcash=68400");
    dispatch(getPopularAtemsAC(data.items));
    dispatch(setToggleDispetcherPopular(false));

}

export const geTagsAtemsAC = (itemsTag) => {

    return {
        type: GET_TAG_ITEMS, itemsTag
    }
}
export const setToggleDispetcherTag = (isFetchingTagsItems) => {
    return {
        type: TOGGLE_IS_DISPETCHER_TAG, isFetchingTagsItems
    }
}

export const setTagsItems = () => async (dispatch) => {

    dispatch(setToggleDispetcherTag(true));
    let data = await getItemsTagAPI.GetItemsTag();
    dispatch(geTagsAtemsAC(data.itemsTags));
    dispatch(setToggleDispetcherTag(false));

}

export default indexPageReducer;